/* eslint-disable object-property-newline */
import { Card } from "react-bootstrap";
import { FilterIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useClassFilters } from "./components/ClassFilterProvider";

const CalendarFiltersAside = ({
	children
}) => {
	const { showFilters } = useClassFilters();
	return (
		<aside
			aria-hidden={!showFilters}
			className={classNames("bg-white", { show: showFilters })}
			id="calendar-filters"
		>
			<Card className="border-0 rounded-0">
				<Card.Body>
					<Card.Title className="mb-4">
						<FilterIcon className="i text-blue i-1x me-2" />

						Filter Events
					</Card.Title>
					{children}
				</Card.Body>
			</Card>
		</aside>
	);
};

CalendarFiltersAside.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element,
		PropTypes.object
	])
};

CalendarFiltersAside.defaultProps = {
	children: null
};

export default CalendarFiltersAside;
